import { useEffect, useRef, useState } from 'react';
import API from '@/lib/api';
import { toast } from 'sonner';
import { SOURCE_TEST_IDS, suggestSourceValue, sourceWarning } from '@/lib/documentSelection';

export const useDocumentSource = ({ id, formRef, prepareSave, history = [], onDocument }) => {
  const [field,setField]=useState('');
  const [selection,setSelection]=useState(null);
  const [value,setDraftValue]=useState('');
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const lock=useRef(false);
  const currentId=useRef(id); currentId.current=id;
  const selectField=f=>{if(lock.current)return;setField(f);setSelection(null);setError('');};
  useEffect(()=>{setField('');setSelection(null);setError('');},[id]);
  const setValue=v=>{if(!lock.current){setDraftValue(v);setError('');}};
  const capture=e=>{
    const key=SOURCE_TEST_IDS[e.target.dataset?.testid];
    if(key && key!==field && !lock.current)selectField(key);
  };
  const onSelect=result=>{
    if(!field||lock.current)return;
    setSelection({...result,vorige_waarde:formRef.current[field]??null});
    setDraftValue(suggestSourceValue(field,result.text));setError('');
  };
  const act=async(path,body)=>{
    if(lock.current)return false;
    lock.current=true;setBusy(true);setError('');
    const requestId=id;
    try {
      if(!(await prepareSave()))throw new Error('Bewaar eerst de factuurwijzigingen en probeer opnieuw.');
      await API.post(path,body,{timeout:90000});
      const {data}=await API.get(`/inkomende-documenten/${id}`,{noCache:true});
      if(currentId.current!==requestId)return false;
      onDocument(data);setSelection(null);
      toast.success(body?'Waarde overgenomen uit document':'Overname ongedaan gemaakt');
      return true;
    } catch(e){if(currentId.current===requestId)setError(e.response?.data?.detail||e.message||'Opslaan mislukt');return false;}
    finally{lock.current=false;setBusy(false);}
  };
  const lastChange=[...history].reverse().find(s=>!s.ongedaan&&s.veld===field);
  return {field,selectField,selection,value,setValue,busy,error,capture,onSelect,lastChange,
    confirm:()=>{
      if(!selection)return Promise.resolve(false);
      const warning=sourceWarning(field,value);
      if(warning){setError(warning);return Promise.resolve(false);}
      return act(`/inkomende-documenten/${id}/veldselectie`,{...selection,veld:field,waarde:value});
    },
    undo:sid=>act(`/inkomende-documenten/${id}/veldselectie/${sid}/ongedaan`),
    cancel:()=>{if(!lock.current){setSelection(null);setError('');}}};
};